import translate from "@insite/client-framework/Translate";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import SignInResetPasswordForm from "@preferredMedical/Overrides/Widgets/SignIn/SignInResetPasswordForm";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    title: string;
    description: string;
    resetPasswordLabel: string;
}

export interface FirstLoginWelcomeStyles {
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    oneLinerGridItem?: GridItemProps;
    resetPasswordModal?: ModalPresentationProps;
}

export const styles: FirstLoginWelcomeStyles = {
    modal: {
        size: 800,
        cssOverrides: {
            modalTitle: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                        `,
                        null,
                        null,
                        css`
                            border-bottom: 0;
                            padding-bottom: 0px;
                            justify-content: center;
                        `,
                        null,
                    ],
                    "min",
                )}
            `,
            titleButton: css`
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                        `,
                        null,
                        null,
                        css`
                            display: none;
                        `,
                        null,
                    ],
                    "min",
                )}
            `,
            modalContent: css`
                padding: 20px 30px;
            `,
        },
    },
    container: {
        gap: 10,
        css: css`
            text-align: left;
        `
    },
    oneLinerGridItem: {
        width: 12,
        css: css`
            padding-left: 10px;
            justify-content: center;
        `,
    },
    resetPasswordModal: {
        sizeVariant: "small",
    },
};

export interface FirstLoginWelcomeState {
    modalIsOpen: boolean,
    isResetPasswordModalOpen: boolean
}

class FirstLoginWelcomeModal extends React.Component<OwnProps, FirstLoginWelcomeState> {
    state = {
        modalIsOpen: true,
        isResetPasswordModalOpen: false
    };

    closeModal = () => {
        this.setState({ modalIsOpen: false });
    };

    onResetPasswordClose = () => {
        this.setState({ isResetPasswordModalOpen: false });
    };

    onResetPasswordOpen = () => {
        this.setState({ modalIsOpen: false, isResetPasswordModalOpen: true });
    };

    render() {
        const { title, description, resetPasswordLabel } = this.props;
        const { modalIsOpen, isResetPasswordModalOpen } = this.state;

        return (
            <>
                <Modal
                    {...styles.modal}
                    headline={title}
                    isOpen={modalIsOpen}
                    handleClose={this.closeModal}
                >
                    <GridContainer {...styles.container}>
                        <GridItem {...styles.oneLinerGridItem}>
                            <div>
                                <Typography>{description}</Typography>
                                <Link
                                    onClick={this.onResetPasswordOpen}
                                    data-test-selector="firstLoginWelcome_resetPassword">
                                    {resetPasswordLabel}
                                </Link>
                            </div>
                        </GridItem>
                    </GridContainer>
                </Modal>
                <Modal
                    headline={translate("Reset Password")}
                    {...styles.resetPasswordModal}
                    isOpen={isResetPasswordModalOpen}
                    handleClose={this.onResetPasswordClose}
                    data-test-selector="resetPasswordModal"
                >
                    <SignInResetPasswordForm onClose={this.onResetPasswordClose} showBackToSignIn={false}/>
                </Modal>
            </>
        );
    }
}

export default FirstLoginWelcomeModal;